import { intl } from "LocaleWrapper";
import { Box, Typography } from "@mui/material";
import { AttributeType, getAttributeColor } from "./utils";

interface AttributesProps {
	selectedAttribute?: AttributeType;
	onSelect: (attribute?: AttributeType) => void;
	onChangeAllowed: boolean;
}

const AttributeItems = [
	{ type: AttributeType._45ft, labelId: "BAYPLAN_45FT_COMPATIBLE" },
	{ type: AttributeType.Blocked, labelId: "BAYPLAN_BLOCKED" },
	{ type: AttributeType.Reefer, labelId: "BAYPLAN_REEFER_COMPATIBLE" },
	{ type: AttributeType.Vertical, labelId: "BAYPLAN_VERTICAL" },
];

const Attributes = ({ selectedAttribute, onSelect, onChangeAllowed }: AttributesProps) => (
	<Box sx={{ display: "flex" }} mb={2}>
		{AttributeItems.map(({ type, labelId }) => {
			const isSelected = type === selectedAttribute;
			return (
				<Box
					key={type}
					sx={{
						alignItems: "center",
						backgroundColor: (theme) => isSelected ? (theme.palette.mode === "dark" ? theme.palette.action.selected : "#ddd") : "inherit",
						borderRadius: "2px",
						display: "flex",
						justifyContent: "center",
						transition: "all 0.3s ease",

						"&:hover": onChangeAllowed ? {
							backgroundColor: (theme) => theme.palette.mode === "dark" ? theme.palette.action.selected : "#ddd",
							cursor: "pointer",
						} : {},
					}}
					px={1}
					py={0.5}
					mr={2}
					onClick={() => {
						if (onChangeAllowed) {
							onSelect(type === selectedAttribute ? undefined : type);
						}
					}}>
					<Box
						sx={{
							backgroundColor: getAttributeColor(type),
							borderRadius: "2px",
							height: "12px",
							width: "16px",
						}}
						mr={1} />

					<Typography variant="caption" sx={{ fontWeight: 600 }}>
						{intl.formatMessage({ id: labelId })}
					</Typography>
				</Box>
			);
		})}
	</Box>
);

export default Attributes;
